import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const EducationHero = () => {
  return (
    <section 
      className="relative py-24 px-4 pt-40"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1523050854058-8df90110c9f1')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/95 to-blue-800/90" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold text-white mb-6">
            Transform Your Educational Institution
          </h1>
          <p className="text-xl text-gray-200 mb-8">
            Empower your institution with cutting-edge digital solutions. From enrollment 
            optimization to student engagement, we help educational organizations thrive 
            in the digital age.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100">
              Schedule a Free Consultation
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};